/* Forever Moments — theme.js
   Tiny runtime for non-critical interactivity.
*/

// Announcement bar — rotator + dismiss
(function () {
  document.querySelectorAll('.announce').forEach(function (bar) {
    // Hide if previously dismissed for this exact message set
    var hash = bar.dataset.announceHash;
    if (hash) {
      try {
        if (localStorage.getItem('fm_announce_dismissed') === hash) {
          bar.hidden = true;
          return;
        }
      } catch (e) { /* localStorage unavailable */ }
    }

    var slides = bar.querySelectorAll('.announce__slide');
    if (slides.length >= 2) {
      var i = 0;
      var interval = parseInt(bar.dataset.rotateMs, 10) || 4500;
      setInterval(function () {
        slides[i].removeAttribute('data-active');
        i = (i + 1) % slides.length;
        slides[i].setAttribute('data-active', 'true');
      }, interval);
    }

    var dismiss = bar.querySelector('[data-announce-dismiss]');
    if (dismiss) {
      dismiss.addEventListener('click', function () {
        bar.hidden = true;
        try { if (hash) localStorage.setItem('fm_announce_dismissed', hash); } catch (e) {}
      });
    }
  });
})();

// Accessible dropdown keyboard support
(function () {
  document.querySelectorAll('.site-nav__item--has-dropdown').forEach(function (item) {
    var trigger = item.querySelector('.site-nav__link');
    if (!trigger) return;
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        var first = item.querySelector('.site-nav__dropdown a');
        if (first) first.focus();
      }
    });
  });
})();

// Mobile nav drawer
(function () {
  var drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeEls = drawer.querySelectorAll('[data-drawer-close]');
  var firstFocusable = drawer.querySelector('.mobile-drawer__close');

  function openDrawer() {
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    if (firstFocusable) firstFocusable.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    setTimeout(function () { drawer.hidden = true; if (openBtn) openBtn.focus(); }, 250);
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  closeEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  // Cart action inside the mobile menu drawer: close this drawer, then open
  // the cart drawer. window.openCartDrawer is exposed by the cart-drawer IIFE
  // below; if it isn't ready (or the cart drawer isn't on the page), fall
  // back to the link's native href.
  var cartAction = drawer.querySelector('[data-mobile-drawer-cart]');
  if (cartAction) {
    cartAction.addEventListener('click', function (e) {
      if (typeof window.openCartDrawer !== 'function') return; // native nav
      e.preventDefault();
      closeDrawer();
      // Wait for the close transition before opening the cart drawer so they
      // don't fight over body scroll-lock or focus.
      setTimeout(function () { window.openCartDrawer(); }, 260);
    });
  }
})();

// Cart drawer — AJAX add-to-cart, qty updates, remove, checkout
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  function getDrawer() { return document.querySelector('[data-cart-drawer]'); }

  function setBodyLock(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function openCartDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    setBodyLock(true);
    // Sitewide hook for third-party floaters (e.g. Essential Loyalty #honeypop-app)
    document.body.setAttribute('data-cart-open', '');
    var close = d.querySelector('.cart-drawer__close');
    if (close) close.focus();
  }
  function closeCartDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    setBodyLock(false);
    document.body.removeAttribute('data-cart-open');
    setTimeout(function () { d.hidden = true; }, 250);
  }

  // Expose for other scripts (e.g. main-product.liquid)
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  // Refresh drawer markup using Section Rendering API
  function refreshDrawer() {
    return fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var current = getDrawer();
        if (!current) return;
        var wasOpen = current.classList.contains('is-open');
        var hidden = current.hidden;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (!fresh) return;
        current.outerHTML = fresh.outerHTML;
        var newDrawer = getDrawer();
        if (newDrawer) {
          if (wasOpen) {
            newDrawer.hidden = false;
            newDrawer.classList.add('is-open');
          } else {
            newDrawer.hidden = hidden;
          }
        }
        wireDrawer();
        updateHeaderCount();
      });
  }

  function updateHeaderCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // .cart-count holds just the number; CSS adds parens on desktop and
        // styles it as a corner badge on mobile (≤768px). data-count drives
        // the empty-state hide (count == 0).
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
      })
      .catch(function () {});
  }

  // Cart-page form (the /cart route) uses real form submit — drawer code only
  // hijacks the small inline qty inputs and Remove links inside the drawer.
  function wireDrawer() {
    var d = getDrawer();
    if (!d) return;

    d.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });

    d.querySelectorAll('[data-cart-qty]').forEach(function (group) {
      var input = group.querySelector('[data-cart-qty-input]');
      var dec = group.querySelector('[data-cart-qty-decrement]');
      var inc = group.querySelector('[data-cart-qty-increment]');
      if (!input) return;
      var key = input.getAttribute('data-key');
      function commit(newQty) {
        if (newQty < 0) newQty = 0;
        input.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
          .then(function () { return refreshDrawer(); })
          .catch(function () { input.disabled = false; });
      }
      if (dec) dec.addEventListener('click', function () {
        commit(Math.max(0, (parseInt(input.value, 10) || 0) - 1));
      });
      if (inc) inc.addEventListener('click', function () {
        commit((parseInt(input.value, 10) || 0) + 1);
      });
      input.addEventListener('change', function () {
        commit(parseInt(input.value, 10) || 0);
      });
    });

    d.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(refreshDrawer);
      });
    });

    var checkoutBtn = d.querySelector('[data-cart-checkout]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        // Capture social media consent into cart attributes before checkout
        var consent = d.querySelector('[data-cart-consent]');
        var value = consent && consent.checked ? 'Yes' : 'No';
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { 'Social Media Consent': value } })
        }).then(function () { window.location.href = '/checkout'; });
      });
    }
  }

  // Intercept add-to-cart form on product pages (and elsewhere)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function (addedItem) {
        // Klaviyo — Added to Cart. Defensive: skips when klaviyo.js hasn't
        // initialized _learnq (i.e. API key blank in theme settings).
        if (window._learnq && addedItem) {
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              window._learnq.push(['track', 'Added to Cart', {
                $value: cart.total_price / 100,
                AddedItemProductName: addedItem.product_title,
                AddedItemProductID: addedItem.product_id,
                AddedItemSKU: addedItem.sku,
                AddedItemImageURL: addedItem.image,
                AddedItemPrice: addedItem.price / 100,
                AddedItemQuantity: addedItem.quantity
              }]);
            })
            .catch(function () { /* analytics is best-effort */ });
        }
        return addedItem;
      })
      .then(function () { return refreshDrawer(); })
      .then(openCartDrawer)
      .catch(function (err) {
        // Fall back to native form submit on failure (e.g. NINEMAGS validation)
        if (err && err.description) {
          alert(err.description);
        } else {
          form.submit();
        }
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  // Header cart pill opens drawer instead of navigating
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.cart-pill');
    if (pill) {
      e.preventDefault();
      openCartDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = getDrawer();
    if (e.key === 'Escape' && d && !d.hidden) closeCartDrawer();
  });

  wireDrawer();
})();
